import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getLabTestCategories } from 'app/entities/lab-test-category/lab-test-category.reducer';
import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getLabPrescriptions } from 'app/entities/lab-prescription/lab-prescription.reducer';
import { getEntities as getAntibiotics } from 'app/entities/antibiotic/antibiotic.reducer';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { createEntity, getEntity, reset, updateEntity } from './user-lab-test-item.reducer';

export const UserLabTestItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const labTestCategories = useAppSelector(state => state.labTestCategory.entities);
  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const labPrescriptions = useAppSelector(state => state.labPrescription.entities);
  const antibiotics = useAppSelector(state => state.antibiotic.entities);
  const userLabTestItemEntity = useAppSelector(state => state.userLabTestItem.entity);
  const loading = useAppSelector(state => state.userLabTestItem.loading);
  const updating = useAppSelector(state => state.userLabTestItem.updating);
  const updateSuccess = useAppSelector(state => state.userLabTestItem.updateSuccess);
  const patientTypeValues = Object.keys(PatientType);

  const handleClose = () => {
    navigate(`/user-lab-test-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getLabTestCategories({}));
    dispatch(getLabTestItems({}));
    dispatch(getLabPrescriptions({}));
    dispatch(getAntibiotics({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...userLabTestItemEntity,
      ...values,
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      category: labTestCategories.find(it => it.id.toString() === values.category?.toString()),
      item: labTestItems.find(it => it.id.toString() === values.item?.toString()),
      labPres: labPrescriptions.find(it => it.id.toString() === values.labPres?.toString()),
      recommendedAntibiotic: antibiotics.find(it => it.id.toString() === values.recommendedAntibiotic?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientType: 'OP',
          ...userLabTestItemEntity,
          glucoUser: userLabTestItemEntity?.glucoUser?.id,
          category: userLabTestItemEntity?.category?.id,
          item: userLabTestItemEntity?.item?.id,
          labPres: userLabTestItemEntity?.labPres?.id,
          recommendedAntibiotic: userLabTestItemEntity?.recommendedAntibiotic?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.userLabTestItem.home.createOrEditLabel" data-cy="UserLabTestItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.userLabTestItem.home.createOrEditLabel">Create or edit a UserLabTestItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-lab-test-item-id"
                  label={translate('tinyMedicRestApp.userLabTestItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.active')}
                id="user-lab-test-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.lastupdated')}
                id="user-lab-test-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.microSec')}
                id="user-lab-test-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.result')}
                id="user-lab-test-item-result"
                name="result"
                data-cy="result"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.timestampentry')}
                id="user-lab-test-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.observation')}
                id="user-lab-test-item-observation"
                name="observation"
                data-cy="observation"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.cursor')}
                id="user-lab-test-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.instructions')}
                id="user-lab-test-item-instructions"
                name="instructions"
                data-cy="instructions"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.readingType')}
                id="user-lab-test-item-readingType"
                name="readingType"
                data-cy="readingType"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.patientType')}
                id="user-lab-test-item-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.exposed')}
                id="user-lab-test-item-exposed"
                name="exposed"
                data-cy="exposed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.limits')}
                id="user-lab-test-item-limits"
                name="limits"
                data-cy="limits"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.statusCode')}
                id="user-lab-test-item-statusCode"
                name="statusCode"
                data-cy="statusCode"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userLabTestItem.groupPanelId')}
                id="user-lab-test-item-groupPanelId"
                name="groupPanelId"
                data-cy="groupPanelId"
                type="text"
              />
              <ValidatedField
                id="user-lab-test-item-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.userLabTestItem.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="user-lab-test-item-category"
                name="category"
                data-cy="category"
                label={translate('tinyMedicRestApp.userLabTestItem.category')}
                type="select"
                required
              >
                <option value="" key="0" />
                {labTestCategories
                  ? labTestCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="user-lab-test-item-item"
                name="item"
                data-cy="item"
                label={translate('tinyMedicRestApp.userLabTestItem.item')}
                type="select"
                required
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="user-lab-test-item-labPres"
                name="labPres"
                data-cy="labPres"
                label={translate('tinyMedicRestApp.userLabTestItem.labPres')}
                type="select"
              >
                <option value="" key="0" />
                {labPrescriptions
                  ? labPrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="user-lab-test-item-recommendedAntibiotic"
                name="recommendedAntibiotic"
                data-cy="recommendedAntibiotic"
                label={translate('tinyMedicRestApp.userLabTestItem.recommendedAntibiotic')}
                type="select"
              >
                <option value="" key="0" />
                {antibiotics
                  ? antibiotics.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-lab-test-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserLabTestItemUpdate;
